import { render, staticRenderFns } from "./DialogAtualizarDadosPessoais.vue?vue&type=template&id=40f0e11f&"
import script from "./DialogAtualizarDadosPessoais.vue?vue&type=script&lang=js&"
export * from "./DialogAtualizarDadosPessoais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports